// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"55a4140e","453":"757ce370","726":"816655bb","987":"11ed1881"}[chunkId] + ".chunk.js";
};